  let navDom = ''
  navBarData.map(el => {
    navDom += '<span class="nav-item" tag='+el+'>'+el+'</span>'
  })
  document.getElementsByClassName('nav-right')[0].innerHTML = navDom

  const navList = document.querySelectorAll('.nav-item')
  navList[0].classList.add('nav_active')
  navList.forEach(element => {
    element.addEventListener('click',function(e){

      if(typeof lazyLoadMedia != 'undefined'){
        lazyLoadMedia.pause();
      }
      
      autoNavBar(element,'nav-right',20)
      
      scrollStatus = 'handle'
      navList.forEach(element => element.classList.remove('nav_active'))
      e.target.classList.add('nav_active')

      const currentTag = e.target.getAttribute('tag')
      let targetModle
      switch(currentTag){
        case 'Overview':
          window.scrollTo(0, 0);
          waitScrollEnd(() => {
            if(typeof lazyLoadMedia != 'undefined'){
              lazyLoadMedia.resume();// 滚完恢复
            }

            scrollStatus = 'auto';
          });
          break;
        default:
          targetModle = document.getElementById(currentTag+'_modle')
          const topDistance = targetModle.getBoundingClientRect().top + window.scrollY - 200
          window.scrollTo({
              top: topDistance,
              behavior: 'smooth'
          });

          waitScrollEnd(() => {
            if(typeof lazyLoadMedia != 'undefined'){
              lazyLoadMedia.resume();// 滚完恢复
            }
            scrollStatus = 'auto';
          });
          break;
      }
    })
  })

  // idle = 150 表示只要 scroll 事件停顿了 150ms 没有再触发，就认为滚动结束了
  function waitScrollEnd(callback, idle = 150) {
    let timer = null;
    let done = false;

    function finish() {
      if (done) return;
      done = true;
      window.removeEventListener('scroll', onScroll);
      clearTimeout(timer);
      callback();
    }

    function onScroll() {
      clearTimeout(timer);
      timer = setTimeout(finish, idle);
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    // 如果滚动距离很短，可能不触发 scroll，或触发后很快结束
    setTimeout(finish, 1500);
  }

  // // 用户主动滚动时也恢复（防止卡在暂停态）
  // function onUserScroll() {
  //   if (scrollStatus !== 'handle') return;
  //   scrollStatus = 'auto';
  //   lazyLoadMedia.resume();
  // }
  // window.addEventListener('wheel', onUserScroll, { passive: true });
  // window.addEventListener('touchmove', onUserScroll, { passive: true });

  const bottomDistance = (element) => {
      const rect = element.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      return viewportHeight - rect.bottom;
  }
  const topDistance = (element) => {
    const rect = element.getBoundingClientRect();
    return rect.top;
  }

  const handheldNav = (nav) => {
      const navItem = document.getElementById(nav+'_modle')
      const diviceWidth = window.innerWidth || document.documentElement.clientWidth
      const navObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
              if (entry.isIntersecting) {
                  if(scrollStatus == 'handle') return
                  const screenH = window.screen.height/2
                  if(bottomDistance(navItem)<screenH && topDistance(navItem)<screenH && topDistance(navItem)>0){
                     const id = entry.target.id
                     const currentTag = id.replace(/_modle/g, '');
                     navList.forEach( (item) => {
                       if(item.getAttribute('tag') == currentTag){
                         item.classList.add('nav_active')
                         autoNavBar(item,'nav-right',20)
                       }else{
                          item.classList.remove('nav_active')
                       }
                     })
                  }
              }
          });
      }, {
          root: null,
          rootMargin: '0px',
          threshold: 0.2 
      });

      navObserver.observe(navItem);
  }

  function isMobileDevice() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/windows phone/i.test(userAgent)) {
          return true;
      }
      if (/android/i.test(userAgent)) {
          return true;
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return true;
      }
      return false;
  }


const reviewActive = (className) =>{
  const pageHandle = document.querySelectorAll(className)
  pageHandle.forEach( item =>{
    item.addEventListener('click',function(){
        const navList = document.querySelectorAll('.nav-item')
        navList.forEach( (item) => {
                       if(item.getAttribute('tag') == 'Reviews'){
                         item.classList.add('nav_active')
                       }else{
                          item.classList.remove('nav_active')
                       }
                     })
    })
  })
}

document.addEventListener('DOMContentLoaded', () => {
    if(navBarData.some(t => t == 'Reviews')){
        const elements = document.getElementsByClassName('jdgm-paginate');
        if (elements.length > 0) {
            // reviewActive('.jdgm-paginate__page')
            reviewActive('.jdgm-paginate')
        } else {
            alert('The page is still loading. Please wait a moment.')
        }
    }
});

  if(isMobileDevice()){
      document.addEventListener('touchstart', handleTouchStart, false);        
      document.addEventListener('touchmove', handleTouchMove, false);
       
      let startY = 0; // 初始Y坐标
      let isScrollingVertically = false; // 是否为竖向滑动
       
      function handleTouchStart(evt) {
          // 记录触摸开始时的Y坐标
          startY = evt.touches[0].clientY;
      }
       
      function handleTouchMove(evt) {
          // 阻止默认滚动行为，以便我们可以检测滑动
          evt.preventDefault();
          
          // 获取当前触摸点的Y坐标
          let currentY = evt.touches[0].clientY;
          let diffY = currentY - startY; // 计算Y方向上的差异
          
          // 判断是否为竖向滑动，这里以滑动距离的绝对值大于10像素为例
          if (Math.abs(diffY) > 20) {
              isScrollingVertically = true; // 设置为竖向滑动
              startY = currentY; // 更新开始Y坐标为当前Y坐标，以便下一次计算
          } else {
              isScrollingVertically = false; // 重置为非竖向滑动
          }
          
          // 根据需要处理滑动事件，例如：
          if (isScrollingVertically) {
              scrollStatus = 'auto'
              console.log('执行---')
              if(typeof lazyLoadMedia != 'undefined'){
                lazyLoadMedia.resume();
              }
              
          } else {
      
          }
      }
    
      //模拟器手机端用，真机注释
      // document.addEventListener('wheel', function(event){
      //   scrollStatus = 'auto'
      // })
  }else{
      document.addEventListener('wheel', function(event){
        scrollStatus = 'auto'

        if(typeof lazyLoadMedia != 'undefined'){
          lazyLoadMedia.resume();
        }
      })
  }
  // 高性能节流函数（结合时间戳）
  function throttle(func, limit = 100) {
    let lastTime = 0;
    return function(...args) {
      const now = Date.now();
      if (now - lastTime >= limit) {
        func.apply(this, args);
        lastTime = now;
      }
    };
  }

//节流函数
var customdebounce = (func, wait) => {
    let timeout;
    return function(...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            func.apply(context, args);
        }, wait);
    };
};

  // 获取滚动位置（兼容写法）
  function getScrollY() {
    return window.pageYOffset 
      || document.documentElement.scrollTop
      || document.body.scrollTop 
      || 0;
  }

  // 滚动处理逻辑
  function handleScroll() {
    const currentScroll = getScrollY();
    if (currentScroll >= 200) {
      document.getElementsByClassName('fixed-nav-bar')[0].style.cssText += 'display: block;';

      navBarData.map((item)=>{
        handheldNav(item)
      })

    } else {
      document.getElementsByClassName('fixed-nav-bar')[0].style.cssText += 'display: none;';
    }
  }

  // 初始化监听
  // const throttledScrollHandler = throttle(handleScroll, 100);
  const throttledScrollHandler = customdebounce(handleScroll, 10);
  window.addEventListener('scroll', throttledScrollHandler, { passive: true });

  // 页面卸载时需要移除监听（示例）
  // window.removeEventListener('scroll', throttledScrollHandler);